import type {PortalMe, PortalRoleName} from 'compob2b-libs';

/** Роли без организации — сотрудники XCMG (поле «Организация» пусто). */
export const XCMG_ROLES: PortalRoleName[] = ['ROLE_XCMG_ADMIN', 'ROLE_XCMG_STAFF'];

/**
 * Текущий пользователь — сотрудник XCMG. У него нет организации, а значит ни портального
 * договора, ни своего вида цены. `null` (аноним, менеджер под покупателем, ошибка `/me`) — нет.
 */
export function isXcmgStaff(me: PortalMe | null | undefined): boolean {
  return !!me?.role && XCMG_ROLES.includes(me.role.name);
}
